"use client";

import * as React from "react";
import { APP_NAME } from "@/lib/constants";
import Link from "next/link";
import { Container } from "@/components/ui/container";

export default function AuthLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="min-h-svh flex flex-col items-center relative justify-center gap-6 bg-background p-6 md:p-10">
      <Container className="max-w-sm">
        <div className="flex flex-col gap-6">
          <Link href="/" className="flex items-center self-center">
            <img src="/cruize-logo.svg" alt={APP_NAME} className="w-auto h-9" />
          </Link>
          {children}
        </div>
      </Container>
    </div>
  );
}
